import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { Skeleton, message } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import SectionHeader from '../../components/SectionHeader'
import SectionHeaderTemplate from '../../components/SectionHeaderTemplate'
import SectionContent from '../../components/SectionContent'
import Spin from '../../components/Spin'
import Form from './Form'
import {
  editForm,
  fetchItem,
  createItem,
  editItem,
  deleteItem,
  reset,
} from '../../actions/actionForm'
import { fetchItems as fetchGoods } from '../../actions/goods'
import { fetchItems as fetchSellers } from '../../actions/sellers'

const listPath = '/admin/actions'
const itemsTitle = 'Акции'
const itemTitle = 'акцией'
const storeKey = 'actionForm'
const storeGoods = 'goods'
const storeSellers = 'sellers'

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleFormOnSubmit = this.handleFormOnSubmit.bind(this)
    this.handleFormOnDelete = this.handleFormOnDelete.bind(this)
    this.props.reset()
  }

  componentDidMount() {
    this.props.fetchGoods() // Goods
    this.props.fetchSellers() // Sellers
    if (this.props.type === 'edit') {
      this.props.fetchItem({ id: this.props.match.params.itemId })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreateItemLoading && nextProps.isCreateItemSuccess) {
      message.success('Новая акция успешно создана.')
    } else if (this.props.isEditItemLoading && nextProps.isEditItemSuccess) {
      message.success('Данные акции успешно изменены.')
    } else if (this.props.isDeleteItemLoading && nextProps.isDeleteItemSuccess) {
      message.success('Акция сеть успешно удалена.')
    } else if (this.props.isCreateItemLoading && nextProps.createItemError) {
      message.error(nextProps.createItemError)
    } else if (this.props.isEditItemLoading && nextProps.editItemError) {
      message.error(nextProps.editItemError)
    } else if (this.props.isDeleteItemLoading && nextProps.deleteItemError) {
      message.error(nextProps.deleteItemError)
    } else if (this.props.isFetchItemLoading && nextProps.fetchItemError) {
      message.error(nextProps.fetchItemError)
    } else if (this.props.isFetchGoodsLoading && nextProps.fetchGoodsError) { // Goods
      message.error(nextProps.fetchGoodsError)
    } else if (this.props.isFetchSellersLoading && nextProps.fetchSellersError) { // Sellers
      message.error(nextProps.fetchSellersError)
    }
  }

  handleFormOnSubmit(values) {
    if (this.props.type === 'create') {
      this.props.createItem(values)
    } else {
      const item = { ...this.props.item, ...values }
      this.props.editItem(item)
    }
  }

  handleFormOnDelete() {
    this.props.deleteItem({ id: this.props.match.params.itemId })
  }

  render() {
    const { type, isCreateItemSuccess, isDeleteItemSuccess } = this.props

    const isCreateForm = type === 'create'
    const actionTitle = isCreateForm ? 'Создать' : 'Управление'

    if (isCreateItemSuccess || isDeleteItemSuccess) {
      return <Redirect to={listPath} />
    }
    return (
      <div>
        <AdminLayout>
          <SectionHeader>
            <SectionHeaderTemplate
              breadcrumbRoutes={[{ path: '/admin', title: 'Главная' }, { path: listPath, title: itemsTitle }, { title: actionTitle }]}
              title={`${actionTitle} ${itemTitle}`}
            />
          </SectionHeader>
          <SectionContent>
            {
              (this.props.isFetchItemLoading && this.props.isFetchGoodsLoading && this.props.isFetchSellersLoading) && <Spin />
            }
            {
              (!this.props.goods && !this.props.sellers) ?
                <Skeleton />
              :
              (isCreateForm || (!isCreateForm && this.props.item)) &&
              <Form
                onSubmit={this.handleFormOnSubmit}
                onDelete={this.handleFormOnDelete}
                onFieldsChange={this.props.editForm}
                formFieldValues={this.props.formFieldValues}
                isCreateItemLoading={this.props.isCreateItemLoading}
                isEditItemLoading={this.props.isEditItemLoading}
                isDeleteItemLoading={this.props.isDeleteItemLoading}
                type={this.props.type}
                goods={this.props.goods} // Goods
                sellers={this.props.sellers} // Sellers
              />
            }
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    formFieldValues,
    isFetchItemLoading,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  } = state[storeKey]

  /* Goods */
  const {
    goods,
    fetchGoodsError,
    isFetchGoodsLoading,
  } = state[storeGoods]

  /* Sellers */
  const {
    sellers,
    fetchSellersError,
    isFetchSellersLoading,
  } = state[storeSellers]

  return {
    isFetchItemLoading,
    formFieldValues,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    isFetchGoodsLoading, // Goods
    goods, // Goods
    fetchGoodsError, // Goods
    sellers, // Sellers
    fetchSellersError, // Sellers
    isFetchSellersLoading, // Sellers
    createItemError,
    editItemError,
    deleteItemError,
  }
}

const mapDispatchToProps = dispatch => ({
  createItem: params => dispatch(createItem(params)),
  editItem: params => dispatch(editItem(params)),
  fetchItem: params => dispatch(fetchItem(params)),
  deleteItem: params => dispatch(deleteItem(params)),
  fetchGoods: params => dispatch(fetchGoods(params)), // Goods
  fetchSellers: params => dispatch(fetchSellers(params)), // Sellers
  editForm: formFieldsChange => dispatch(editForm(formFieldsChange)),
  reset: () => dispatch(reset()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemForm))



// WEBPACK FOOTER //
// src/containers/ActionForm/index.jsx